import React from 'react';
import { Table } from 'antd';
import dayjs from 'dayjs';

const displayCell = (value) => {
  if (value === 0 || value === '0') return '—';
  if (value === null || value === undefined || value === '') return '—';
  return value;
};

const formatSupplyDate = (supplyDate) => {
  if (!supplyDate) return '—';
  const parsed = dayjs(supplyDate);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : supplyDate;
};

const SUMMARY_COLUMNS = [
  {
    title: 'Sr.',
    key: 'sr',
    width: 48,
    render: (_, __, index) => index + 1,
  },
  {
    title: 'Item',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
  {
    title: 'Available Qty',
    dataIndex: 'availableQuantity',
    key: 'availableQuantity',
    width: 110,
    render: displayCell,
  },
  {
    title: 'Supply Date',
    dataIndex: 'supplyDate',
    key: 'supplyDate',
    width: 110,
    render: formatSupplyDate,
  },
  {
    title: 'Quoted Price',
    dataIndex: 'quotedPrice',
    key: 'quotedPrice',
    width: 110,
    render: displayCell,
  },
  {
    title: 'Negotiated Price',
    dataIndex: 'negotiatedPrice',
    key: 'negotiatedPrice',
    width: 120,
    render: displayCell,
  },
];

export default function QuotationRejectItemsSummary({ items = [] }) {
  if (!items.length) return null;

  return (
    <div className="Quotation_rejectItemsSummary">
      <p className="Quotation_rejectItemsSummary_count">
        {items.length} item(s) selected for rejection
      </p>
      <Table
        size="small"
        bordered
        pagination={false}
        rowKey={(row) => row._id || row.itemRef}
        columns={SUMMARY_COLUMNS}
        dataSource={items}
        scroll={{ x: true }}
      />
    </div>
  );
}
